import { BoxesIcon, Edit, ExternalLink, MoreHorizontal, Trash2 } from "lucide-react"
import { Button } from "./Button/Button"
import { DropdownMenu } from "./Dropdown/Dropdown"
import { useLangContext } from "context/Lang"
import { DropdownMenuItemProps } from "./Dropdown/DropdownType"
// import { Button } from "./ui/button"
// import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu"




export const ActionsDrop = ({
    onEdit,
    onDelete,
    onGo,
    onViewBuild,
    morActions
}: {
    onEdit?: () => void,
    onDelete?: () => void,
    onGo?: () => void,
    onViewBuild?:()=>void,
    morActions?: DropdownMenuItemProps[]

}) => {
    const { gW } = useLangContext();







    return <>
        <DropdownMenu
            trigger={<Button variant="ghost" size="sm" className="hover:bg-background-secondary">
                <MoreHorizontal className="w-4 h-4" />
            </Button>}
            items={[
                onEdit && {
                    icon: <Edit className="w-4 h-4 " />,
                    label: <> {gW("edit")}</>,
                    onClick: () => onEdit?.()
                },
                onGo && {
                    icon: <ExternalLink className="w-4 h-4 " />,
                    label: <> {gW("go")}</>,
                    onClick: () => onGo?.()
                },
                onDelete && {
                    icon: <Trash2 className="w-4 h-4 " />,
                    label: <> {gW("delete")}</>,
                    onClick: () => onDelete?.()
                },
                onViewBuild&& {
                    icon: <BoxesIcon className="w-6 h-6 " />,
                    label: <> {gW("view-building")}</>,
                    onClick: () => onViewBuild?.()
                },
                ...morActions||[]
            ]}
        />

    </>
}